import React from 'react';
import './App.css'; 

const HomeFr = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.png" alt="Logo"/>
        <p className="centered-paragraph">
    Naviguez sur le web avec votre montre ! Accès rapide aux favoris. Élevez votre expérience de navigation dès maintenant avec une navigation web rapide, une recherche intelligente et une connectivité sans faille pour votre montre intelligente. Profitez d'une expérience de navigation fluide et efficace directement depuis votre poignet !
</p>

        <a href='https://apps.apple.com/app/surfify-web-browser-on-watch/id6478813759?ppid=121505f9-a6b7-4285-b495-15bdd2bac71d'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
        </div>
        </>
     );
}
 
export default HomeFr;